export const COMMISSION_TYPE_WHOLESALE = 'wholesale';
export const COMMISSION_TYPE_UNIT_PRICE = 'unit';
export const COMMISSION_TYPE_MSRP = 'MSRP';
export const COMMISSION_TYPE_REV_SHARE = 'rev_share';
export const COMMISSION_TYPE_CUSTOM = 'custom';

export const multiCurrencyCommissionFields = [
  { type: COMMISSION_TYPE_WHOLESALE, label: 'Wholesale Cost' },
  { type: COMMISSION_TYPE_MSRP, label: 'Retail Price' },
  { type: COMMISSION_TYPE_REV_SHARE, label: 'Rev Share' },
];
